import { useConsultores } from './useConsultores';
import { ConsultorFormData } from '../types/consultor';

export function useConsultoresSteps() {
  const consultoresHook = useConsultores();

  // Wrapper para a função de salvar
  const handleSave = async (data: ConsultorFormData, id?: string) => {
    return await consultoresHook.saveConsultor(data, id);
  };

  return {
    ...consultoresHook,
    saveConsultor: handleSave,
  };
} 